import { modelRequest } from "@stem-sims/nexus"
import { AccountInfoProps } from "../types/accountTypes"

/**
 * Gets account information for the user
 */
export function get(): Promise<AccountInfoProps> {
    return modelRequest.get("/api/account/info")
}

export function generateApiKey(): Promise<string> {
    return modelRequest.put("/api/account/api-key")
}
